import { Component } from '@angular/core';
import { DateRange, MomentHelper } from '../../models/date';
import {
  emptyFields, OrderStatusOptions, TransactionTypeOptions, Country,
  ReportTerminals, settlementStatusOptions, UsersType, TopupOptions,
  TransactionAccountTypeOptions, TransactionAccountTypes, settlementStatusText, PaymentMethodOptions, appCodeValue, FooterStaticValue, gstColumnName, ReportTerminal, TransactionAccountTypeOptionsNew
} from '../../utilities/common-file';
import { NzTableData } from '../../utilities/nz-table.adapter';
import { MerchantTransactionSearch } from '../../models/merchant-transactions';
import { TransactionService } from '../../transactions/transactions.service';
import { countries } from '../../utilities/countries';
import { DownloadService } from '../download-service';
import { AuthService } from 'src/app/auth/auth.service';
import { Messages } from 'src/app/utilities/message';
import * as moment from 'moment';
import { CommonService } from 'src/app/utilities/common-service';
import { ViewTransactionsComponent } from '../../view-details/view-transaction.component';
import { NzDrawerService, NzNotificationService } from 'src/app/utilities/ng-zorro-antd.module';
import { ViewReceiptsComponent } from 'src/app/view-receipts/view-receipts.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-transactions-report',
  templateUrl: './transactions.component.html',
})
export class TransactionsComponent {
  transactionStatusList = OrderStatusOptions;
  transactionTypeList = TransactionTypeOptions;
  reportTerminal=ReportTerminal;
  showDownload: string;
  loading = false;
  emptyField = emptyFields;
  country = Country;
  merchantId: any;
  locationId: any;
  selectedTransaction: any;
  selectedMerchant: any;
  countries = countries;
  selectedRateDateRange: Date[] = null;
  transactionAccountTypes = TransactionAccountTypes;
  accountTypeOptions = TransactionAccountTypeOptions;
  topupOptions = TopupOptions;
  settlementStatus = settlementStatusOptions;
  merchantCurrency = '';
  loginUserType = '';
  showFields = false;
  locationsList = [];
  downloadList = [];
  userType = UsersType;
  textForSettlementStatus = settlementStatusText;
  notifyLogout: any;
  paymentMethodOptions = PaymentMethodOptions;
  totalAmount = 0;
  currencySymbol = '';
  totalBankFee = 0;
  totalTransactionFee = 0
  totalNetAmount = 0;
  totalCommission = 0;
  totalGST = 0;
  grandTotal = 0;
  showTotalAmount = false;
  totalFlexmGst = 0;
  totalFlexmFee = 0;
  isMonthlyTransferFee:any=localStorage.getItem('monthly_transfer_fee')==='true'
  gst:any = localStorage.getItem('gst');
  hst:any = localStorage.getItem('hst');
  gstColumnName = gstColumnName;
  columnName :any;
  encryptedAmount = FooterStaticValue.encryptedAmount;
  public tableData: NzTableData<MerchantTransactionSearch, any> = new NzTableData<MerchantTransactionSearch, any>
    (new MerchantTransactionSearch(), 'transactionStatus');

  constructor(
    public transactionService: TransactionService,
    public authService: AuthService,
    public downloadService: DownloadService,
    public commonService: CommonService,
    public drawerService: NzDrawerService,
    public notification: NzNotificationService

  ) {

  }
  // tslint:disable-next-line: use-lifecycle-interface
  ngOnInit() {
    if(this.isMonthlyTransferFee){
      this.accountTypeOptions = [...TransactionAccountTypeOptionsNew];
     }else{
      this.accountTypeOptions = [...TransactionAccountTypeOptions];
     }
    this.hst = (this.hst === "true");
    this.gst = (this.gst === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    this.tableData.search.isSettled = '';
    this.tableData.search.accountType = '';
    this.tableData.search.paymentMethod = '';
    this.merchantId = this.authService.getMerchantId();
    this.locationId = this.authService.getLocationId();
    this.loginUserType = this.authService.getRole();

    // To Show Transaction Fee, Bank Fee, Net Amont transfer fields in grid based on Login user Type

    this.showFields = this.authService.showOptionsBasedOnUserType();
    if (this.locationId) {
      this.tableData.search.locationId = this.locationId;
    }
    this.getMerchant();
    this.getLocations();
    this.refresh();
  }
  getMerchant() {
    this.selectedMerchant = this.authService.getMerchantDetails();
    this.merchantCurrency = this.selectedMerchant.currency;
    this.getLocations();
  }
  getLocations() {
    this.locationsList = this.authService.getLocationDetails();
  }
  sort(sort: { key: string; value: string }): void {
    this.tableData.setSort(sort);
    this.refresh();
  }

  onUpdatedOnChange(range: any[]) {
    if (range.length <= 1) {
      return;
    }
    this.tableData.search.createdDate = MomentHelper.createDateRange(range);
    this.refresh();
  }
  updateClear(range: any[]) {
    if (range.length <= 1) {
      this.tableData.search.createdDate = DateRange.empty();
      return;
    }
  }
  refresh(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    this.tableData.search.accountType = this.commonService.getTransactionAccountTypeWithExternalPayment
      (this.tableData.search.accountType);
    this.transactionService.getMerchantTransactionListView(this.tableData).subscribe((response: any) => {
      this.loading = false;
      this.tableData.total = response.data.total;
      this.tableData.data = response.data.transactions;
      this.showDownload = Messages.downloadReport;
      this.currencySymbol = this.commonService.getCurrencySymbol(this.authService.getAppCode() === appCodeValue.all ? '' : this.authService.getAppCode());
      if (startFromPageOne) { this.showTotalAmount = false; }
    }, () => {
      this.loading = false;
      this.tableData.data = [];
      this.showDownload = '';

    });
  }
  //Footer data show
  transactionSummaryTriggered() {
    this.getTransactionSummary(false);
  }
  getTransactionSummary(isDownload) {
    if ((this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) || !isDownload) {
      this.tableData.search.merchantId = this.selectedMerchant.id;
      this.transactionService.merchantTransactionSummary(this.tableData).subscribe((response: any) => {
        this.totalAmount = response.data.totalAmount.toFixed(2);
        this.totalTransactionFee = response.data.totalTransactionFee.toFixed(2);
        // this.totalBankFee=response.data.totalBankFee.toFixed(2);
        this.totalNetAmount = response.data.totalNetAmount.toFixed(2);
        // this.totalBankFee = response.data.totalBankFee.toFixed(2);
        this.grandTotal = response.data.grandTotal.toFixed(2),
          this.totalCommission = response.data.totalCommission.toFixed(2);
        this.totalGST = response.data.totalGst.toFixed(2);
        this.totalFlexmGst = response.data.totalFlexmGst.toFixed(2);
        this.totalFlexmFee = response.data.totalFlexmFee.toFixed(2);
        this.currencySymbol = this.commonService.getCurrencySymbol(this.tableData.search.appCode);
        if (isDownload) { this.downloadExcelFromBuffer(); } else { this.showTotalAmount = true; }
      }, () => {
        this.loading = false;
        this.tableData.data = [];
        this.showDownload = '';
      });
    } else {
      this.notification.error(Messages.noDateSelected, '', {
        nzKey: 'key'
      });
    }
  }
  onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.refresh(false);
  }
  getTransactionType(mode) {
    return this.commonService.getTransactionAccountType(mode);
  }
  // tslint:disable-next-line: indent
  getColorForTransactionType(mode) {
    return this.commonService.getColorForTransactionAccountType(mode);
  }
  getSettlementStatus(status) {
    return this.commonService.getSettlementStatus(status);
  }
  getColorForSettlementStatus(status) {
    return this.commonService.getColorForSettlementStatus(status);
  }
  getCurrency(currency) {
    const index = this.countries.findIndex(M => M.currency_code === currency);
    if (index !== -1) {
      return this.countries[index].currency_symbol;
    }
  }
  clearSearch(value) {
    return this.transactionService.clearSearchFields(this.tableData, value);
  }
  viewTransaction(data) {
    this.selectedTransaction = data;
    const drawerRefCreate = this.drawerService.create<ViewTransactionsComponent, { id: string, merchantDetails: any }, string>({
      nzContent: ViewTransactionsComponent,
      nzWidth: '700px',
      nzClosable: true,
      nzContentParams: {
        id: data.id,
        merchantDetails: this.selectedMerchant
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    // For drawer Close on Logout
    drawerRefCreate.afterOpen.subscribe(() => {
      this.notifyLogout = this.authService.notify.subscribe((result) => {
        if (result) {
          drawerRefCreate.close();
        }
      });
    });
    drawerRefCreate.afterClose.subscribe((data) => {
      if (data && typeof data !== null) {
        this.refresh();
      }
    });
  }
  viewReceipt(data) {
    this.selectedTransaction = data;
    const drawerReceipt = this.drawerService.create<ViewReceiptsComponent, { id: any, type: string }, string>({
      nzContent: ViewReceiptsComponent,
      nzWidth: '750px',
      nzClosable: true,
      nzContentParams: {
        id: this.selectedTransaction.id,
        type: 'merchant'
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        padding: '0'
      }
    });
    // tslint:disable-next-line: no-shadowed-variable
    drawerReceipt.afterClose.subscribe((data) => {
      if (data && typeof data !== null) {
      }
    });
  }
  downloadExcelFromBuffer(){
    if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
      this.notification.info('Download Processing', 'Please Wait', {
        nzKey : 'key'
      });
      const value = {
        startDate: this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '',
        endDate: this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '',
        transactionStatus: this.tableData.search.transactionStatus,
        transactionType: this.tableData.search.transactionType,
        settlementStatus: this.tableData.search.settledStatus,
        isSettled: this.tableData.search.isSettled,
        accountTypeIn: this.tableData.search.accountType ? this.tableData.search.accountType :[''],
          // [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.settlement,
          // TransactionAccountTypes.refund],
        mobileNo: this.tableData.search.type === 'mobile_no' ? this.tableData.search.number : '',
        accountNo: this.tableData.search.type === 'account_no' ? this.tableData.search.number : '',
        paymentMethod: this.tableData.search.paymentMethod,
        // tslint:disable-next-line: radix
        id: this.tableData.search.id ? parseInt(this.tableData.search.id) : '',
        name: this.tableData.search.name,
        merchantId: parseInt(this.authService.getMerchantId()),
        locationId: this.tableData.search.locationId ? this.tableData.search.locationId : '',
        isBufferData:true,
        reportTerminal:this.reportTerminal.MerchantBoardTransactionReportNew
      };
      this.transactionService.downloadMerchantTransactionReportNew(value).subscribe((response: any) => {
        this.downloadList = response.data.data;
        // this.downloadList = response.data.data;
        const bufferArray = new Uint8Array(response.data.data.data);
        const blob = new Blob([bufferArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const reader = new FileReader();
        reader.onload = () => {
          const arrayBuffer = reader.result as ArrayBuffer;
          const workbook = XLSX.read(arrayBuffer, { type: 'array' });
          const data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
          // Provide an option for the user to download the Excel file
          const blobForDownload = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = URL.createObjectURL(blobForDownload);
          const a = document.createElement('a');
          a.href = url;
          const fileNameForFile = ReportTerminals.merchantTransactionReportNew + '_' + moment().format('DDMMYYYYhhmmss') + '.xlsx';
          a.download = fileNameForFile
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          this.notification.remove('key');
        };
        reader.readAsArrayBuffer(blob);
      });
    } else {
      this.notification.error(Messages.noDateSelected, '', {
        nzKey : 'key'
      });
    }
  }
  downloadReport() {
    if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
      this.notification.info('Download Processing', 'Please Wait', {
        nzKey: 'key'
      });
      const value = {
        startDate: this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '',
        endDate: this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '',
        transactionStatus: this.tableData.search.transactionStatus,
        transactionType: this.tableData.search.transactionType,
        settlementStatus: this.tableData.search.settledStatus,
        isSettled: this.tableData.search.isSettled,
        accountTypeIn: this.tableData.search.accountType ? this.tableData.search.accountType :
          [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.settlement,
          TransactionAccountTypes.refund],
        mobileNo: this.tableData.search.type === 'mobile_no' ? this.tableData.search.number : '',
        accountNo: this.tableData.search.type === 'account_no' ? this.tableData.search.number : '',
        paymentMethod: this.tableData.search.paymentMethod,
        // tslint:disable-next-line: radix
        id: this.tableData.search.id ? parseInt(this.tableData.search.id) : '',
        name: this.tableData.search.name,
        merchantId: parseInt(this.authService.getMerchantId()),
        locationId: this.tableData.search.locationId ? this.tableData.search.locationId : '',
      };
      this.tableData.search.accountType = this.commonService.getTransactionAccountTypeWithExternalPayment
        (this.tableData.search.accountType);
 
      const filterHeaders = ['Created On', 'Location Name', 'Payment Method', 'Transaction Type', 'Settlement Status',
        this.tableData.search.type === 'mobile_no' ? 'Mobile Number' : 'Account Number', 'Transaction Id', 'Display Name'];
      const filterData = [this.tableData.search.createdDate ? moment(this.tableData.search.createdDate.startDate).
        local().format('DD-MMM-YYYY') + ' to ' + moment(this.tableData.search.createdDate.endDate).local().format('DD-MMM-YYYY') : '',
      this.tableData.search.locationId ? this.locationsList.find(x => x.id === this.tableData.search.locationId).name : 'All',
      this.tableData.search.paymentMethod ? this.tableData.search.paymentMethod : 'All',
      this.tableData.search.accountType ? this.getTransactionType(this.tableData.search.accountType[0]) : 'All',
      this.tableData.search.isSettled === '' ? 'All' : this.tableData.search.isSettled ? 'Settled' : 'Un Settled',
      this.tableData.search.type === 'mobile_no' ? (this.tableData.search.number ? this.tableData.search.number.toString() : '')
        : this.tableData.search.type === 'account_no' ? this.tableData.search.number : '',
      this.tableData.search.id ? this.tableData.search.id : '',
      this.tableData.search.name ? this.tableData.search.name : ''
      ];
      // For Footer 
      var gridFooter;
    var footerData;
      if (this.showFields && this.gst) {
        gridFooter = ['Total Amount', 'Total TransactionFee','Total '+this.columnName,'Total FlexM Fee','Total Commission', 'Total GST', 'Grand Commission Total', 'Total Net Amount'];
        footerData = [
          this.currencySymbol + this.totalAmount,
          this.currencySymbol + this.totalTransactionFee,
          this.currencySymbol + this.totalFlexmGst,
          this.currencySymbol + this.totalFlexmFee,
          this.currencySymbol + this.totalCommission,
          this.currencySymbol + this.totalGST,
          this.currencySymbol + this.grandTotal,
          // this.currencySymbol+this.totalBankFee,
          this.currencySymbol + this.totalNetAmount,
        ];
      } else {
        gridFooter = ['Total Amount']
        footerData = [
          this.currencySymbol + this.totalAmount,
        ]
      }
      this.transactionService.downloadMerchantTransactionReportNew(value).subscribe((response: any) => {
        this.downloadList = response.data.transactions;
        let headers = [];
        if (this.downloadList.length > 0) {
          if (this.showFields && this.gst) {
            headers = ['Transaction ID', 'Document No', 'Account No', 'Mobile No', 'Display Name', 'Location Name',
              'Settlement No', 'Total Transaction Amount(' + this.getCurrency(this.merchantCurrency) + ')',
              'Transaction Fee (' + this.getCurrency(this.merchantCurrency) + ')',this.columnName +'(' + this.getCurrency(this.merchantCurrency) + ')','Total Flexm Fee (' + this.getCurrency(this.merchantCurrency) + ')',
              'Commission (' + this.getCurrency(this.merchantCurrency) + ')', 'GST(' + this.getCurrency(this.merchantCurrency) + ')', 'Total Commission(' + this.getCurrency(this.merchantCurrency) + ')',
              // 'Bank Fee (' + this.getCurrency(this.merchantCurrency) + ')',
              'Net Amount Transferred (' + this.getCurrency(this.merchantCurrency) + ')', 'Payment Method',
              'Transaction Type', 'Settlement Status', 'Narration', 'Created Date', 'Created By'];
          } else {
            headers = ['Transaction ID', 'Document No', 'Account No', 'Mobile No', 'Display Name', 'Location Name',
              'Settlement No', 'Total Transaction Amount(' + this.getCurrency(this.merchantCurrency) + ')', 'Payment Method',
              'Transaction Type', 'Settlement Status', 'Narration', 'Created Date', 'Created By'];
          }
          // tslint:disable-next-line: max-line-length
          this.downloadService.onDownloadExcel(headers, ReportTerminals.merchantTransactionReportNew, this.tableData.search.createdDate.startDate, this.tableData.search.createdDate.endDate, this.downloadList, ReportTerminals.merchantTransactionReportNew, ReportTerminals.merchantTransactionReportNew, filterHeaders, filterData, gridFooter, footerData);
        }
      });
    } else {
      this.notification.error(Messages.noDateSelected, '', {
        nzKey: 'key'
      });
    }
  }
  // PaymentMethod
  getPaymentMethod(mode) {
    return this.commonService.getPaymentMethod(mode);
  }
  // PaymentMethodColor
  getColorForPaymentMethod(mode) {
    return this.commonService.getColorForPaymentMethod(mode);
  }
  getUserNameForPaynow(narration: string) {
    var paynow;
    if (narration) {
      paynow = narration.startsWith("Merchant Pay, Paynow") || narration.startsWith("Settlement")|| narration.startsWith("Monthly Transfer Fee");
      return paynow;
    } else {
      return false;
    }
  }
}
